import React from "react";

const StatusBadge = ({ status, className = "" }) => {
  const getStatusConfig = status => {
    switch (status?.toUpperCase()) {
      case "ACTIVE":
        return {
          label: "Active",
          className: "bg-green-100 text-green-800 border-green-200",
          dotColor: "bg-green-400",
        };
      case "INACTIVE":
        return {
          label: "Inactive",
          className: "bg-yellow-100 text-yellow-800 border-yellow-200",
          dotColor: "bg-yellow-400",
        };
      case "DISABLED":
        return {
          label: "Disabled",
          className: "bg-red-100 text-red-800 border-red-200",
          dotColor: "bg-red-400",
        };
      case "SUSPENDED":
        return {
          label: "Suspended",
          className: "bg-orange-100 text-orange-800 border-orange-200",
          dotColor: "bg-orange-400",
        };
      default:
        return {
          label: status || "Unknown",
          className: "bg-gray-100 text-gray-800 border-gray-200",
          dotColor: "bg-gray-400",
        };
    }
  };

  const config = getStatusConfig(status);

  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${config.className} ${className}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full mr-1.5 ${config.dotColor}`}></span>
      {config.label}
    </span>
  );
};

export default StatusBadge;
